import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  CreateLotGalleryImageInput,
  CreateLotGalleryImagesDocument,
  CreateLotGalleryImagesMutation,
  DataAccessService,
  FindHomeByIdDocument,
  FindHomeByIdQuery,
  RemoveLotGalleryImagesDocument,
  RemoveLotGalleryImagesMutation,
  UpdateLotGalleryOrderDocument,
  UpdateLotGalleryOrderMutation
} from '@tripointe/tripointe-cms/data-access';
import { ApolloQueryResult } from '@apollo/client/core';
import { finalize } from 'rxjs/operators';

export enum MediaType {
  Photo = 1,
  Video = 2
}

@Injectable({
  providedIn: 'root'
})
export class HomeGalleryService {
  loading$ = new BehaviorSubject(false);

  constructor(private dataAccess: DataAccessService) {}

  setLoading(isLoading: boolean): void {
    this.loading$.next(isLoading);
  }

  getLotById(id: number): Observable<ApolloQueryResult<FindHomeByIdQuery>> {
    this.setLoading(true);

    return this.dataAccess
      .get<FindHomeByIdQuery>(FindHomeByIdDocument, { id })
      .pipe(finalize(() => this.setLoading(false)));
  }

  deletePhotos(
    lotPhotosIds: number[]
  ): Observable<ApolloQueryResult<RemoveLotGalleryImagesMutation>> {
    this.setLoading(true);

    return this.dataAccess.update(RemoveLotGalleryImagesDocument, { lotPhotosIds }).pipe(
      finalize(() => {
        this.setLoading(false);
      })
    );
  }

  updatePhotosOrder(
    lotGalleryIds: number[],
    lotId: number
  ): Observable<ApolloQueryResult<UpdateLotGalleryOrderMutation>> {
    this.setLoading(true);

    return this.dataAccess.update(UpdateLotGalleryOrderDocument, { lotGalleryIds, lotId }).pipe(
      finalize(() => {
        this.setLoading(false);
      })
    );
  }

  createLotGallery(
    createLotGalleryImagesInput: CreateLotGalleryImageInput[],
    lotId: number
  ): Observable<ApolloQueryResult<CreateLotGalleryImagesMutation>> {
    this.setLoading(true);

    return this.dataAccess
      .update(CreateLotGalleryImagesDocument, { createLotGalleryImagesInput, lotId })
      .pipe(
        finalize(() => {
          this.setLoading(false);
        })
      );
  }
}
